import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import Login from './pages/auth/Login';
import { Home } from './pages/home/Home';
import AuthErrorHandler from './components/auth/AuthErrorHandler';
import IntakeForm from './pages/intake/IntakeForm';
import IntakeSuccess from './pages/intake/IntakeSuccess';

function App() {

  return (
    <>
      <Router>
        <Routes>
          {/* <Route
            path='/'
            element={
              isLoggedIn ? (hasSelectedCompany ? (<Home />) : (<Navigate to='/company' />)) : (<Login />)
            }
          /> */}
          {/* <Route path='*' element={isLoggedIn ? <Home /> : <Login />} /> */}
          
          {/* New routes */}
          <Route path="/" element={<Navigate to="/app/leads" replace />} />

          {/* Authentication routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/intake" element={<IntakeForm />} />
          <Route path="/intake/success" element={<IntakeSuccess />} />
          
          {/* Fallback: if no route matches, show Home */}
          <Route path="*" element={<Home />} />

          
          {/* <Route path="/" element={<Navigate to="/contacts" replace />} /> */}
          {/* <Route
            path='/'
            element={isLoggedIn ? <Home /> : <Login />
            // <Navigate to='/login' />
          }
          >
          </Route> */}
        </Routes>
        
        {/* Global Auth Error Handler */}
        <AuthErrorHandler />
      </Router>
    </>
  );
}

export default App;
